import { STATS } from "@/lib/mock";

const PILLARS = [
  {
    k: "Level Subfloor Prep",
    v: "The difference between flooring that lasts 3 years and 30. We prep every subfloor: leveled, moisture-sealed, primed. It's the reason our floors don't lift, cup, or grow gaps.",
  },
  {
    k: "Hand-Cut Precision",
    v: "Every plank scored on-site, every tile cut for tight seams and flush transitions. No off-the-shelf shortcuts — just clean lines, tight grout, and finishes you'll be proud to walk on.",
  },
  {
    k: "Workmanship Guarantee",
    v: "If a plank lifts or a tile cracks on a floor we installed, we come back. No fine print. No fees. That's the M&L promise.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="py-16 lg:py-24 bg-stone-900 text-stone-100 relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -top-32 -left-32 w-[600px] h-[600px] rounded-full opacity-25 blur-[140px] pointer-events-none"
        style={{
          background: "radial-gradient(circle, rgba(234,88,12,0.7) 0%, rgba(234,88,12,0) 70%)",
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12 lg:mb-16">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 text-xs font-semibold text-orange-400 mb-4">
              <span className="w-1.5 h-1.5 bg-orange-500 rounded-full" />
              WHY M&amp;L
            </div>
            <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.025em] text-stone-50">
              We don't cut what
              <br />
              <span className="text-orange-400">holds it up.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-stone-300 text-lg leading-relaxed max-w-md">
              Most flooring failures happen at the subfloor. We don't cut
              corners on prep — and we don't disappear after install.
            </p>
          </div>
        </div>

        {/* Pillars */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 lg:mb-16">
          {PILLARS.map((p, i) => (
            <div
              key={p.k}
              className="bg-stone-800/60 backdrop-blur-sm border border-stone-700/50 p-8 rounded-2xl hover:border-orange-500/40 transition-colors"
            >
              <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center text-stone-50 font-bold text-sm mb-6">
                0{i + 1}
              </div>
              <div className="font-display font-semibold text-2xl text-stone-50 leading-tight mb-3">
                {p.k}
              </div>
              <p className="text-stone-400 leading-relaxed text-[15px]">{p.v}</p>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              data-testid={`stat-${i}`}
              className="text-center md:text-left"
            >
              <div className="font-display font-semibold text-5xl lg:text-6xl tracking-tight text-stone-50 leading-none">
                {s.value.includes("+") ? (
                  <>
                    {s.value.replace("+", "")}
                    <span className="text-orange-400">+</span>
                  </>
                ) : s.value.includes("★") ? (
                  <>
                    {s.value.replace("★", "")}
                    <span className="text-orange-400">★</span>
                  </>
                ) : (
                  s.value
                )}
              </div>
              <div className="mt-3 text-xs uppercase tracking-wider text-stone-400 font-medium">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
